import styled from "styled-components";

import { blueMui } from "@ryde/theme";

import { DATA_E2E_KEY } from "../../constants";
import { IStyledAttributes } from "../../models";

export const ToastBoxStyled = styled.div`
  .message {
    font-size: 15px;
  }
  .details {
    font-size: 13px;
  }
`;

export const ToastActionBoxStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "toast-action-box",
})`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .toast-message {
    font-size: 15px;
  }

  .toast-action {
    align-self: flex-start;
    padding: 0;
    border: none;
    background: none;
    font-size: 14px;
    font-weight: 600;
    color: ${blueMui._700};
    text-decoration: underline;
    cursor: pointer;
  }
`;
